'use strict'

INBOX_SELECTORS = {
  ITEM_COUNT_TWO_CHARS: 'item-count-two-chars'
  ITEM_COUNT_THREE_CHARS: 'item-count-three-chars'
  ITEM_TIME_CLASS: '.ls-inbox-item-time'
  ITEM_TIME_DATA_ATTR: 'start'
  SHOW_INBOX_CLASS: 'ls-show-inbox'
}

TIMES = [
  {
    text: 's'
    secs: 1
    canPlural: false
  },
  {
    text: 'm'
    secs: 60
    canPlural: false
  },
  {
    text: 'h'
    secs: 60 * 60
    canPlural: false
  },
  {
    text: ' day'
    secs: 60 * 60 * 24
    canPlural: true
  },
  {
    text: ' week'
    secs: 60 * 60 * 24 * 7
    canPlural: true
  },
  {
    text: ' month'
    secs: 60 * 60 * 24 * 7 * 4
    canPlural: true
  }
]

hideSearchResults = ->
  document.getElementById('ls-search-results').removeAttribute('style')

toggleAriaAttributes = (inboxElem) ->
  hiddenAttr = inboxElem.getAttribute('aria-hidden')
  value = if hiddenAttr is 'true' then 'false' else 'true'
  inboxElem.setAttribute('aria-hidden', value)
  inboxElem.classList.toggle('ls-hide')

updateTimestamps = (inboxElem) ->
  timeElems = inboxElem.querySelectorAll(INBOX_SELECTORS.ITEM_TIME_CLASS)
  numTimes = TIMES.length
  nowDate = Date.now()
  [].forEach.call timeElems, (el) ->
    return if not el.dataset[INBOX_SELECTORS.ITEM_TIME_DATA_ATTR]

    startDate = new Date(el.dataset[INBOX_SELECTORS.ITEM_TIME_DATA_ATTR])
    timeSince = nowDate - startDate
    secsSince = parseInt(timeSince / 1000)
    for i in [0...numTimes]
      timeData = TIMES[i]
      if (i + 1) < numTimes
        if secsSince >= TIMES[i + 1].secs
          continue
      time = Math.floor(secsSince / timeData.secs)
      text = time + timeData.text
      if timeData.canPlural and time > 1
        text += 's'
      break

    if text?
      if child = el.firstChild
        el.removeChild child
      el.appendChild document.createTextNode(text)
  return

updateUnviewedCount = (bellElem, unviewedCount) ->
  countElem = bellElem.querySelector('.item-count')
  if unviewedCount > 0
    if not countElem
      countElem = document.createElement('div')
      countElem.classList.add('item-count')
      bellElem.appendChild(countElem)
      newElem = true

    if unviewedCount >= 100
      countElem.innerHTML = '99+'
      countElem.classList.remove INBOX_SELECTORS.ITEM_COUNT_TWO_CHARS unless newElem
      countElem.classList.add INBOX_SELECTORS.ITEM_COUNT_THREE_CHARS
    else if unviewedCount >= 10
      countElem.innerHTML = unviewedCount.toString()
      countElem.classList.remove INBOX_SELECTORS.ITEM_COUNT_THREE_CHARS unless newElem
      countElem.classList.add INBOX_SELECTORS.ITEM_COUNT_TWO_CHARS
    else
      countElem.classList.remove(INBOX_SELECTORS.ITEM_COUNT_TWO_CHARS + ', ' + INBOX_SELECTORS.ITEM_COUNT_THREE_CHARS) unless newElem
      countElem.innerHTML = unviewedCount.toString()
  else
    if countElem
      bellElem.removeChild countElem
  return

module.exports = {
  updateUnviewedCount,
  toggleAriaAttributes,
  updateTimestamps,
  hideSearchResults
}
